
const initialState = {
    HandleExisteDeuda: {
        ExisteDeuda: null,
        TotalDeuda: null,
        ErrorApi: null,
    },
    HandleSwitchsStates: null
};

const storeReducer = (state, action) => {
    switch (action.type) {
        case 'ExisteDeuda': {
            return {
                ...state,
                HandleExisteDeuda: {
                    ExisteDeuda: action.value.ExisteDeuda,
                    TotalDeuda: action.value.TotalDeuda,
                    ErrorApi: action.value.ErrorApi,
                },
            };
        }
        case 'SwitchsStates': {
            return {
                ...state,
                HandleSwitchsStates: action.value
            }
        }
    }
    return state;
};
export { initialState, storeReducer };
